import React from 'react'
import { Link } from "react-router-dom";
import icondocumentacion from '../assets/images/icons/documento.png'
import iconAuto from '../assets/images/icons/auto.png'
import iconMenor from '../assets/images/icons/menor.png'
import iconPata from '../assets/images/icons/pata.png'
import iconAnciano from '../assets/images/icons/anciano.png'
import iconEmbarazada from '../assets/images/icons/embarazada.png'

import '../css/documentacion.scss'

export default function documentacion() {
    return (

        <section className='documentacion'>

    <div className='container'>

        <div className='documentacion-title'>
            <h2 className='title-icon'>
                <i className="fi fi-rs-document-signed"></i>
                <span>Documentación</span>
            </h2>
        </div>

        <div className='documentacion-grid'>

            {/* CARD */}
            <div className='documentacion-box'>
                <div className='documentacion-content-icon'>
                    <img src={icondocumentacion} alt='' />
                </div>

                <div className='documentacion-content-box'>

                    <div className='documentacion-content-title'>
                        <h3>Documentación para viajar</h3>
                    </div>

                    <div className='documentacion-content-text'>
                        <p>
                            Encuentra toda la información y requisitos
                            que debes presentar antes de iniciar tu viaje.
                        </p>
                    </div>

                    <div className='documentacion-content-cta'>
                        <Link to="/documentacion-para-viajar">
                            Ver más
                            <i className="fi fi-rr-arrow-right"></i>
                        </Link>
                    </div>

                </div>
            </div>

            {/* CARD */}
            <div className='documentacion-box'>
                <div className='documentacion-content-icon'>
                    <img src={iconAuto} alt='' />
                </div>

                <div className='documentacion-content-box'>

                    <div className='documentacion-content-title'>
                        <h3>¿Viajas con vehículo?</h3>
                    </div>

                    <div className='documentacion-content-text'>
                        <p>
                            Consulta los documentos y requisitos para
                            embarcar tu automóvil, incluyendo papeles
                            del vehículo.
                        </p>
                    </div>

                    <div className='documentacion-content-cta'>
                        <Link to="/viajar-con-auto">
                            Ver más
                            <i className="fi fi-rr-arrow-right"></i>
                        </Link>
                    </div>

                </div>
            </div>

            {/* CARD */}
            <div className='documentacion-box'>
                <div className='documentacion-content-icon'>
                    <img src={iconMenor} alt='' />
                </div>

                <div className='documentacion-content-box'>

                    <div className='documentacion-content-title'>
                        <h3>Menores de edad</h3>
                    </div>

                    <div className='documentacion-content-text'>
                        <p>
                            Conoce los requisitos para que niños y
                            adolescentes puedan viajar con seguridad.
                        </p>
                    </div>

                    <div className='documentacion-content-cta'>
                        <Link to="/viajar-con-menores-de-edad">
                            Ver más
                            <i className="fi fi-rr-arrow-right"></i>
                        </Link>
                    </div>

                </div>
            </div>

            {/* CARD */}
            <div className='documentacion-box'>
                <div className='documentacion-content-icon'>
                    <img src={iconPata} alt='' />
                </div>

                <div className='documentacion-content-box'>

                    <div className='documentacion-content-title'>
                        <h3>Viajar con mascotas</h3>
                    </div>

                    <div className='documentacion-content-text'>
                        <p>
                            Encuentra la información necesaria
                            para embarcar con tu mascota:
                            requisitos y cuidados.
                        </p>
                    </div>

                    <div className='documentacion-content-cta'>
                        <Link to="/viajar-con-mascotas">
                            Ver más
                            <i className="fi fi-rr-arrow-right"></i>
                        </Link>
                    </div>

                </div>
            </div>

            {/* CARD */}
            <div className='documentacion-box'>
                <div className='documentacion-content-icon'>
                    <img src={iconAnciano} alt='' />
                </div>

                <div className='documentacion-content-box'>

                    <div className='documentacion-content-title'>
                        <h3>Documentación para adulto mayor</h3>
                    </div>

                    <div className='documentacion-content-text'>
                        <p>
                            Revisa la documentación necesaria para el
                            embarque de adultos mayores y servicios disponibles.
                        </p>
                    </div>

                    <div className='documentacion-content-cta'>
                        <Link to="/viajar-con-adulto-mayor">
                            Ver más
                            <i className="fi fi-rr-arrow-right"></i>
                        </Link>
                    </div>

                </div>
            </div>

            {/* CARD */}
            <div className='documentacion-box'>
                <div className='documentacion-content-icon'>
                    <img src={iconEmbarazada} alt='' />
                </div>

                <div className='documentacion-content-box'>

                    <div className='documentacion-content-title'>
                        <h3>Mujeres embarazadas</h3>
                    </div>

                    <div className='documentacion-content-text'>
                        <p>
                            Información sobre las condiciones,
                            restricciones y cuidados para viajar durante la gestación.
                        </p>
                    </div>

                    <div className='documentacion-content-cta'>
                        <Link to="/documentacion-para-mujeres-embarazadas">
                            Ver más
                            <i className="fi fi-rr-arrow-right"></i>
                        </Link>
                    </div>

                </div>
            </div>

        </div>

    </div>

</section>

       
    )
}
